/**
 * RichText - rich text content block.
 * Custom element: <rich-text>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class RichText extends ThemeComponent {}
setFunctionName(RichText, "RichText");
const propertyTypes = {};
RichText.prototype.$name = "RichText";
RichText.prototype.$info = JSON.parse('{"name":"RichText","meta":{"isLegacy":false,"selector":"rich-text"},"props":[],"refs":[]}');
RichText.prototype.$info.component = RichText;
for (const prop of RichText.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("RichText/RichText.ts", {
  RichText: RichText
}, void 0);